const portfolioBaseUrl = '/Portfolio';

export default {
    getAllPortfolioUrl: () => `${portfolioBaseUrl}/all`,
    getPortfolioByIdUrl: (portfolioId) => `${portfolioBaseUrl}?PortfolioId=${portfolioId}`,
    portfolioInquiry: () => `${portfolioBaseUrl}/inquiry`,
    getPortfolioCitiesUrl: (portfolioId) => `${portfolioBaseUrl}/cities?PortfolioId=${portfolioId}`,
};
